import { isValid as dateIsValid } from 'date-fns';

type DateInput = string | number | Date;

export const parseDate = (date: DateInput | null): Date | null => {
  const dateObj = new Date(date as DateInput);
  if (date !== null && dateIsValid(dateObj)) {
    return dateObj;
  }
  return null;
};

export const orderByDate = <T>(arr: T[], dateProp: keyof T): T[] =>
  arr.slice().sort((a, b) => (a[dateProp] < b[dateProp] ? -1 : 1));

export const daysBetween = (date1: DateInput, date2: DateInput): number => {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const firstDate = new Date(date1);
  const secondDate = new Date(date2);

  return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));
};

export const addYears = (date: DateInput, years: number): Date => {
  const dateCopy = new Date(date);
  dateCopy.setFullYear(dateCopy.getFullYear() + years);
  return dateCopy;
};
